import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  max-width: 1300px;
  display: flex;
  flex-direction: column;
  padding-bottom: 50px;

  h1 {
    text-align: left;
    margin: 0;
    color: #1a1a1a;
    font-size: 24px;
  }

  .header-actions {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 15,
      flex-wrap: wrap;
  }

  .filters {
      display: flex;
      gap: 15px;
      flex-wrap: wrap;
      align-items: flex-end;
      margin-bottom: 30px;
      background: #f9f9f9;
      padding: 20px;
      border-radius: 15px;
      border: 1px solid #eee;
  }

  /* Novo Estilo de Listagem */
  .leads-list {
      display: flex;
      flex-direction: column;
      gap: 12px;
  }

  .lead-card {
      background: #fff;
      padding: 15px 25px;
      border-radius: 12px;
      border: 1px solid #f0f0f0;
      display: grid;
      grid-template-columns: 2fr 1.5fr 1.5fr 1.2fr 1fr 80px;
      align-items: center;
      transition: all 0.2s ease;
      box-shadow: 0 2px 8px rgba(0,0,0,0.02);

      &:hover {
          border-color: #008037;
          box-shadow: 0 4px 12px rgba(0,0,0,0.08);
          transform: translateX(5px);
      }

      @media (max-width: 1000px) {
          grid-template-columns: 1fr 1fr;
          gap: 15px;
          padding: 20px;
      }

      .main-info {
          display: flex;
          flex-direction: column;
          strong { font-size: 15px; color: #333; }
          span { font-size: 12px; color: #999; }
      }

      .contact-info {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 13px;
          color: #666;
          svg { color: #008037; }
      }

      .date-info {
          font-size: 13px;
          color: #888;
          display: flex;
          flex-direction: column;
          label { font-size: 10px; text-transform: uppercase; color: #bbb; }
      }

      .actions {
          display: flex;
          justify-content: flex-end;
          gap: 12px;
      }

}

  .value-info {
      padding: 5px 12px;
      display: flex;
      flex-direction: column;
      text-align: center;
      margin-right: 25px;
      width: 160px;
      

      &.pendente { color: #8c8c8c; }
      &.fechado { color: #52c41a; }
      &.perdido { color: #f5222d; }
      &.default { color: #faad14; }
      strong { font-size: 15px }
      span { font-size: 12px }
  }

  .status-badge {
      padding: 5px 12px;
      border-radius: 50px;
      font-size: 11px;
      font-weight: 700;
      text-transform: uppercase;
      text-align: center;
      width: fit-content;
      
      &.pendente { background: #fff1f0; color: #f5222d; border: 1px solid #ffa39e; }
      &.oportunidade { background: #e6f7ff; color: #1890ff; border: 1px solid #91d5ff; }
      &.atendimento { background: #f9f0ff; color: #722ed1; border: 1px solid #d3adf7; }
      &.fechado { background: #f6ffed; color: #52c41a; border: 1px solid #b7eb8f; }
      &.perdido { background: #f5f5f5; color: #8c8c8c; border: 1px solid #d9d9d9; }
      &.default { background: #fffbe6; color: #faad14; border: 1px solid #ffe58f; }
  }
  
`;

export const AssociateInfo = styled.div`
  background: #f8faf9;
  border: 1px solid #d7f0db;
  border-radius: 10px;
  padding: 15px;
  margin-top: 20px;
  display: flex;
  gap: 15px;
  align-items: center;

  img {
    width: 60px !important;
    height: 60px !important;
    border-radius: 8px !important;
    object-fit: cover;
    margin: 0 !important;
  }

  .info {
    display: flex;
    flex-direction: column;

    strong {
      font-size: 14px;
      color: #333;
    }
    span {
      font-size: 12px;
      color: #666;
    }
  }
`;

export const InfoTag = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 15px 0;

  .tag {
    background: #f0f0f0;
    padding: 4px 12px;
    border-radius: 50px;
    font-size: 11px;
    color: #555;
    border: 1px solid #e0e0e0;
    display: flex;
    align-items: center;
    gap: 5px;
  }
`;

export const Label = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 2px;
  display: inline-block;
  background: ${(props) => props.color};
`;
